module.exports = __webpack_public_path__ + "fontawesome-webfont.c8ddf1e5e5bf3682bc7b.woff";


//////////////////
// WEBPACK FOOTER
// C:/Users/TerrellDavis/Documents/GitHub/AVL/realavl/realavl/src/fonts/fontawesome-webfont.woff?v=4.6.3
// module id = ../../../../../src/fonts/fontawesome-webfont.woff?v=4.6.3
// module chunks = styles